module.exports = __webpack_public_path__ + "img/appImg.f6c0da9f.png";